(function () {
  function clearScrollLock() {
    document.body.classList.remove('flashes-lightbox-open');
    document.body.style.removeProperty('overflow');
    document.body.style.removeProperty('padding-right');
  }

  function parseFlashesData(section) {
    var template = section.querySelector('[data-flashes-lightbox-data]');
    if (!template) return [];

    try {
      return JSON.parse(template.innerHTML.trim()) || [];
    } catch (error) {
      return [];
    }
  }

  function layoutPatternGrid(grid) {
    if (!grid) return;

    var label = grid.getAttribute('data-flashes-pattern-label') || 'ang3lbyt';
    var gapStyle = window.getComputedStyle(grid);
    var gapX = parseFloat(gapStyle.columnGap) || 12;
    var gapY = parseFloat(gapStyle.rowGap) || 5.6;
    var probeCell = document.createElement('span');
    var probeWord = document.createElement('span');

    probeCell.className = 'flashes-lightbox__pattern-cell';
    probeWord.className = 'flashes-lightbox__pattern-word';
    probeWord.textContent = label;
    probeCell.appendChild(probeWord);
    probeCell.style.visibility = 'hidden';
    probeCell.style.position = 'absolute';
    probeCell.style.pointerEvents = 'none';
    grid.appendChild(probeCell);

    var wordWidth = Math.ceil(probeWord.getBoundingClientRect().width);
    var wordHeight = Math.ceil(probeWord.getBoundingClientRect().height);
    grid.removeChild(probeCell);

    if (!wordWidth || !wordHeight) return;

    var viewportW = window.innerWidth;
    var viewportH = window.innerHeight;
    var stepX = wordWidth + gapX;
    var stepY = wordHeight + gapY;
    var cols = Math.max(1, Math.ceil(viewportW / stepX) + 2);
    var rows = Math.max(1, Math.ceil(viewportH / stepY) + 2);
    var total = cols * rows;
    var fragment = document.createDocumentFragment();
    var index = 0;

    grid.style.gridTemplateColumns = 'repeat(' + cols + ', max-content)';
    grid.style.columnGap = gapX + 'px';
    grid.style.rowGap = gapY + 'px';
    grid.textContent = '';

    for (; index < total; index += 1) {
      var cell = document.createElement('span');
      var word = document.createElement('span');

      cell.className = 'flashes-lightbox__pattern-cell';
      word.className = 'flashes-lightbox__pattern-word';
      word.textContent = label;
      cell.appendChild(word);
      fragment.appendChild(cell);
    }

    grid.appendChild(fragment);
  }

  function initFlashesSection(section) {
    if (section.dataset.flashesBound === 'true') return;
    section.dataset.flashesBound = 'true';

    var items = parseFlashesData(section);
    if (!items.length) return;

    var root = section.querySelector('[data-flashes-lightbox-root]');
    var backdrop = section.querySelector('[data-flashes-lightbox-backdrop]');
    var closeBtn = section.querySelector('[data-flashes-lightbox-close]');
    var prevBtn = section.querySelector('[data-flashes-lightbox-prev]');
    var nextBtn = section.querySelector('[data-flashes-lightbox-next]');
    var figure = section.querySelector('[data-flashes-lightbox-figure]');
    var stage = section.querySelector('[data-flashes-lightbox-stage]');
    var loader = section.querySelector('[data-flashes-lightbox-loader]');
    var image = section.querySelector('[data-flashes-lightbox-image]');
    var caption = section.querySelector('[data-flashes-lightbox-caption]');
    var patternGrid = section.querySelector('[data-flashes-pattern-grid]');
    var triggers = section.querySelectorAll('[data-flashes-trigger]');

    if (!root || !backdrop || !closeBtn || !image || !triggers.length) return;

    if (root.parentElement !== document.body) {
      document.body.appendChild(root);
    }

    var isOpen = false;
    var activeIndex = 0;
    var activeTrigger = null;
    var resizeTimer = null;

    function lockScroll() {
      var scrollbarW = window.innerWidth - document.documentElement.clientWidth;
      if (scrollbarW > 0) {
        document.body.style.paddingRight = scrollbarW + 'px';
      }
      document.body.classList.add('flashes-lightbox-open');
    }

    function setSlideLoading(loading) {
      if (loader) {
        loader.hidden = !loading;
        loader.setAttribute('aria-busy', loading ? 'true' : 'false');
      }
      image.classList.toggle('is-loading', loading);
    }

    function renderSlide(index) {
      var item = items[index];
      if (!item) return;

      activeIndex = index;
      image.alt = item.alt || '';

      if (item.width) image.width = item.width;
      if (item.height) image.height = item.height;

      if (stage) {
        if (item.width && item.height) {
          stage.style.aspectRatio = item.width + ' / ' + item.height;
        } else {
          stage.style.removeProperty('aspect-ratio');
        }
      }

      if (item.caption) {
        caption.textContent = item.caption;
        caption.hidden = false;
      } else {
        caption.textContent = '';
        caption.hidden = true;
      }

      if (prevBtn) prevBtn.disabled = index <= 0;
      if (nextBtn) nextBtn.disabled = index >= items.length - 1;

      function onImageReady() {
        if (stage) {
          stage.style.removeProperty('aspect-ratio');
        }
        setSlideLoading(false);
      }

      setSlideLoading(true);
      image.src = item.src;

      if (image.complete && image.naturalWidth > 0) {
        onImageReady();
      } else {
        image.addEventListener('load', onImageReady, { once: true });
        image.addEventListener('error', onImageReady, { once: true });
      }
    }

    function openAt(index, trigger) {
      if (isOpen) return;
      if (index < 0 || index >= items.length) return;

      isOpen = true;
      activeTrigger = trigger || null;
      renderSlide(index);

      root.removeAttribute('hidden');
      root.classList.add('is-open');
      root.setAttribute('role', 'dialog');
      root.setAttribute('aria-modal', 'true');
      root.setAttribute('aria-label', 'Image viewer');
      lockScroll();

      requestAnimationFrame(function () {
        layoutPatternGrid(patternGrid);
      });

      if (activeTrigger) {
        activeTrigger.setAttribute('aria-expanded', 'true');
      }
    }

    function closeLightbox() {
      if (!isOpen) return;
      isOpen = false;
      clearScrollLock();
      root.classList.remove('is-open');

      if (activeTrigger) {
        activeTrigger.setAttribute('aria-expanded', 'false');
        activeTrigger = null;
      }

      window.setTimeout(function () {
        if (!isOpen) {
          root.setAttribute('hidden', '');
          root.removeAttribute('role');
          root.removeAttribute('aria-modal');
          root.removeAttribute('aria-label');
          setSlideLoading(false);
          image.removeAttribute('src');
        }
      }, 0);
    }

    function showRelative(step) {
      var nextIndex = activeIndex + step;
      if (nextIndex < 0 || nextIndex >= items.length) return;
      renderSlide(nextIndex);
    }

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var index = parseInt(trigger.getAttribute('data-flashes-index'), 10);
        openAt(index, trigger);
      });
    });

    closeBtn.addEventListener('click', closeLightbox);
    backdrop.addEventListener('click', closeLightbox);

    if (figure) {
      figure.addEventListener('click', function (event) {
        event.stopPropagation();
      });
    }

    root.addEventListener('click', function (event) {
      if (!isOpen) return;
      if (figure && figure.contains(event.target)) return;
      if (event.target.closest('[data-flashes-lightbox-close]')) return;
      if (event.target.closest('[data-flashes-lightbox-prev]')) return;
      if (event.target.closest('[data-flashes-lightbox-next]')) return;
      closeLightbox();
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        showRelative(-1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        showRelative(1);
      });
    }

    document.addEventListener('keydown', function (event) {
      if (!isOpen) return;

      if (event.key === 'Escape') {
        closeLightbox();
        return;
      }

      if (event.key === 'ArrowLeft') {
        showRelative(-1);
        return;
      }

      if (event.key === 'ArrowRight') {
        showRelative(1);
      }
    });

    window.addEventListener('resize', function () {
      if (!isOpen) return;
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () {
        layoutPatternGrid(patternGrid);
      }, 120);
    });
  }

  function boot() {
    clearScrollLock();
    document.querySelectorAll('[data-flashes-section]').forEach(initFlashesSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.addEventListener('pageshow', clearScrollLock);

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.matches('[data-flashes-section]')
      ? event.target
      : event.target.querySelector('[data-flashes-section]');
    if (section) initFlashesSection(section);
  });
})();
